'use client';

import { ShieldEnergyIcon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { isPlainRecord } from '@terra/shared-dto-chat-types';
import { ReasonHeaderAction } from './reason-header-action';

export function readGuardrailFeedback(input: unknown): string | undefined {
  if (!isPlainRecord(input)) {
    return undefined;
  }

  const feedback = input.guardrailFeedback;

  return typeof feedback === 'string' && feedback.trim().length > 0
    ? feedback
    : undefined;
}

export function GuardrailReasonHeaderAction({
  feedback,
}: {
  feedback: string;
}): ReactNode {
  const t = useTranslations(
    'designSystem.chat.hitlRequestConfirmationPromptCard',
  );

  return (
    <ReasonHeaderAction
      title={t('guardrailReasonTooltipTitle')}
      reason={feedback}
      icon={<ShieldEnergyIcon size={14} />}
      color="fg.error"
    />
  );
}

export function getGuardrailReasonHeaderAction(
  input: unknown,
): ReactNode | undefined {
  const feedback = readGuardrailFeedback(input);

  return feedback ? (
    <GuardrailReasonHeaderAction feedback={feedback} />
  ) : undefined;
}
